import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from '@sm/wds-react';
import { getAuthFooterLinks } from './helpers';
import { InlineList, InlineListItem } from '../InlineList';
import { SMFooterContext } from '../SMFooterContext';

const AuthedFooterLinks = ({ domain, lang }) => {
  const { onetrustBannerEnabled, isPrivateLabel } = useContext(SMFooterContext);
  const links = getAuthFooterLinks(domain, lang, isPrivateLabel);
  return (
    <Row>
      <Col>
        <InlineList noMargin>
          {links.map((item, index) => {
            return (
              <InlineListItem
                href={item.url}
                // eslint-disable-next-line react/no-array-index-key
                key={`${item.title}-${index}`}
              >
                {item.title}
              </InlineListItem>
            );
          })}
          <If condition={onetrustBannerEnabled}>
            <li className="sm-inline-list__item">
              {/* Onetrust pipes in the text content here */}
              {/* eslint-disable-next-line jsx-a11y/anchor-has-content */}
              <a
                href="#cookiePreferences"
                className="ot-sdk-show-settings"
                data-testid="AuthedFooterLinks__cookiePreferences"
              />
            </li>
          </If>
        </InlineList>
      </Col>
    </Row>
  );
};

AuthedFooterLinks.propTypes = {
  domain: PropTypes.string,
  lang: PropTypes.string,
};

AuthedFooterLinks.defaultProps = {
  domain: 'surveymonkey',
  lang: 'en',
};

export default AuthedFooterLinks;
